import { useEffect, useState } from "react";
import { getFormatedTimeMiliSeconds } from "../../utils/format";
import "./Timer.css";

interface Props {
  milliSecondsTimeduration: number;
  setIsTimeExpired: React.Dispatch<React.SetStateAction<boolean>>;
  setStartTimer: React.Dispatch<React.SetStateAction<boolean>>;
  startTimer: boolean;
}

const Timer: React.FC<Props> = ({
  milliSecondsTimeduration,
  setIsTimeExpired,
  setStartTimer,
  startTimer,
}) => {
  const [remainingTime, setTime] = useState<number>(milliSecondsTimeduration);
  const [timerId, setTimerId] = useState<NodeJS.Timeout | number>();
  const [initialDate] = useState<Date>(new Date());

  useEffect(() => {
    if (remainingTime === 0) {
      console.log("Clear timer: ", timerId);
      clearInterval(timerId);
      setStartTimer(false);
      setIsTimeExpired(true);
    }
  }, [remainingTime]);

  function refreshTime() {
    if (initialDate) {
      const newTime =
        milliSecondsTimeduration -
        (new Date().getTime() - new Date(initialDate).getTime());
      setTime(newTime < 1000 ? 0 : newTime);
    } else {
      setTime(milliSecondsTimeduration);
    }
  }

  useEffect(() => {
    if (!initialDate) return;
    refreshTime();

    clearInterval(timerId);
    setTimerId(
      setInterval(() => {
        refreshTime();
      }, 1000)
    );
  }, [initialDate]);

  return <>{getFormatedTimeMiliSeconds(remainingTime)}</>;
};

export default Timer;
